import {
  EventNamesMap,
  SearchHistoryClickEventData,
  SearchHistoryViewEventData,
  useAmplitude,
} from 'src/context/AmplitudeProvider';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';

export const useTrackSearchHistoryEvents = () => {
  const { user } = useAuthContext();
  const { logEvent } = useAmplitude();

  const trackSearchHistoryView = (
    data: Omit<SearchHistoryViewEventData, 'user_id' | 'user_email'>
  ) => {
    logEvent(EventNamesMap.SearchHistoryView, {
      ...data,
      user_email: user?.email,
      user_id: user?.pk,
    });
  };

  const trackSearchHistoryClick = (
    data: Omit<SearchHistoryClickEventData, 'user_id' | 'user_email'>
  ) => {
    logEvent(EventNamesMap.SearchHistoryClick, {
      ...data,
      user_email: user?.email,
      user_id: user?.pk,
    });
  };

  return {
    trackSearchHistoryView,
    trackSearchHistoryClick,
  };
};
